import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LocaleService {
  private readonly storageKey = "donorQuestionnaireLocale";
  private readonly fallbackLocale = "en";
  private readonly localeSubject = new BehaviorSubject<string>(
    this.getStoredLocale()
  );

  readonly locale$ = this.localeSubject.asObservable();

  get currentLocale(): string {
    return this.localeSubject.value;
  }

  setLocale(locale: string | null | undefined): void {
    const normalizedLocale = locale?.trim();

    if (!normalizedLocale) {
      return;
    }

    localStorage.setItem(this.storageKey, normalizedLocale);
    this.localeSubject.next(normalizedLocale);
  }

  syncFromUrl(url: string): void {
    const query = url.split("?")[1]?.split("#")[0];

    if (!query) {
      return;
    }

    const locale = new URLSearchParams(query).get("locale");
    this.setLocale(locale);
  }

  private getStoredLocale(): string {
    return localStorage.getItem(this.storageKey) || this.fallbackLocale;
  }

}
